/* eslint-disable no-unused-vars */
/* eslint-disable no-empty */
import { Fragment, useCallback, useEffect, useState } from 'react';
import { BrowserRouter as Router, Link, Route, Routes, useNavigate, useLocation } from 'react-router-dom';
import React from 'react';
import { v4 as uuidv4 } from 'uuid';
import { Button, Table, TableBody, TableContainer, Paper, TablePagination, Grid, Typography, ListItem, ListItemIcon, ListItemText, Box, List } from '@mui/material';
import './LandingPage.scss';
import { REQUEST_ACTIONS, sendRequest, setCookie, getCookie } from '../../utils/Communicator';
import { useDispatch, useSelector } from 'react-redux';
import { getSession, setShipping_list_count, setShipping_list, setPackages, setIsShippingLoading, setShippingCoPoints } from '../../reducers/user-reducers/UserSlicer';
import { snackbarToggle } from '../../reducers/snackbarSlicer';
import { URL, LANGUAGES, chWtMultiplier } from '../../constants/global-constants';
import { Dialog, Snackbar, ConfirmDialog, AlertDialog } from '../../style-guide';
import { checkForgotPasswordRequestExists, activateRegister, getShipmentCost, ping, getShippingRequestCount, getShippingRequestList, get_params, logout } from '../../reducers/requestHandler';
import EnHeader from '../Header/EnHeader';
import HeHeader from '../Header/HeHeader';
import Forgot from '../Forgot/Forgot';
import ActivateUser from '../ActivateUser/ActivateUser';
import Login from '../Login/Login';
import NewHomeHeader from '../NewHome/NewHomeHeader';
import Personal from '../Personal/Personal';
import BuyMePayment from '../BuyMePayment/BuyMePayment';
import Home from '../Home/Home';
import HowItWorks from '../HowItWorks/HowItWorks';
import UsRetailers from '../UsRetailers/UsRetailers';
import RedboxPricing from '../RedboxPricing/RedboxPricing';
import FAQS from '../FAQS/FAQS';
import Howto from '../FAQS/Howto';
import ContactUs from '../ContactUs/ContactUs';
import Accounts from '../Accounts/Accounts';
import Footer from '../Footer/Footer';
import Registration from '../Registration/Registration';
import Profile from '../Registration/Profile';
import Store from '../Store/Store';
import Blog from '../aboutNew/Blog';
import Wrapper from './Wrapper';
import AddAddress from '../AddAddress/AddAddress';
import loadBanner from '../../images/homepage/redbox_pres_3.jpg';
import postReg from '../../images/homepage/postReg.png';
import loginPopup from '../../images/homepage/loginPopup.png';
import NewHome from '../NewHome/NewHome';
import MetaTags from 'react-meta-tags';
import About from '../aboutNew/About';
import Compare from '../aboutNew/Compare';
import OrcaReg from '../aboutNew/OrcaReg';
import Status from '../aboutNew/Status';
import LoadingImg from '../../images/Spin-loader.gif';

import { isNativeApp } from '../../utils/nativeApp';
import DeleteAccount from '../DeleteAccount/DeleteAccount';

export const LandingPage = () => {
    const { userInfo, innerContent } = useSelector(state => state.user);
    const { snackbar } = useSelector(state => state.snackbar);
    const navigate = useNavigate();
    const onSnackbarHandleClose = () => dispatch(snackbarToggle(false));
    const location = useLocation();
    const [activeScreenInreg, setActiveScreenInreg] = new useState('Registeration');
    const [userName, setUserName] = new useState("");
    const [password, setPassword] = new useState("");
    const [isEnable, setEnabled] = new useState(true);
    const [isPackageLoaded, setPackageLoaded] = new useState(false);
    const [hasError, setHasError] = new useState(false);
    const dispatch = useDispatch();
    const failedCallback = useCallback(message => dispatch(snackbarToggle({ type: 'error', message })), [dispatch]);
    const [isLoaded, setIsLoaded] = useState(true);
    const [isPersonal, setIsPersonal] = useState(false);
    const [isBuyMePayment, setIsBuyMePayment] = useState(false);
    const [isRegister, setIsRegister] = useState(false);
    const [isLogin, setIsLogin] = useState(false);
    const [isForgot, setIsForgot] = useState(false);
    const [isActivateUser, setIsActivateUser] = useState(false);
    const [tokenForCh, setTokenForCh] = useState("");
    const [isChangePass, setIsChangePass] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isLoading1, setIsLoading1] = useState(false);
    const [isLoadDlg, setisLoadDlg] = useState(false);
    const [isAddAddress, setIsAddAddress] = useState(false);
    const [isProfile, setIsProfile] = useState(false);
    const [couponList, setCouponList] = new useState([]);
    const doPing = (e) => {
        var sessionId = getCookie("SESSION_ID");
        const params = new URLSearchParams(window.location.search);
        const session = params.get('session');
        if (session) {
            sessionId = session;
        }

        ping(sessionId, function (response) {
            if (response.misc.CODE === 1) {
                setCookie("SESSION_ID", response.session, 30);
                dispatch(getSession(response))
                if (response.session) {
                    var ht = window.location.href;
                    var ht1 = ht.split("?");
                    var ht2 = ht1[0].split("/")
                    var ht3 = ht2[3];
                    if (ht3 == "accounts") {
                        get_shipping_list_count();
                    }
                } else {
                    var ht = window.location.href;
                    var ht1 = ht.split("?");
                    var ht2 = ht1[0].split("/")
                    var ht3 = ht2[3];
                    if (ht3 == "accounts") {
                        var target = "/?target=login";
                        var action = get_params("shId");
                        if (action) {
                            target = "/?target=login&shId=" + action;
                        }
                        window.setTimeout(function () {
                            window.location.href = target;
                        }, 1000);
                    }
                }
                //navigate("/home")
                //  ping();
            } else {
                var ht = window.location.href;
                var ht1 = ht.split("?");
                var ht2 = ht1[0].split("/")
                var ht3 = ht2[3];
                if (ht3 == "accounts") {
                    var target = "/?target=login";
                    var action = get_params("shId");
                    if (action) {
                        target = "/?target=login&shId=" + action;
                    }
                    window.setTimeout(function () {
                        window.location.href = target;
                    }, 1000);
                }
            }
        })
    }
    const isMobile = () => /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    const logOutUser = (e) => {
        logout(getCookie("SESSION_ID"), function (response) {
            if (response.misc.CODE === 1) {
                setCookie("SESSION_ID", "", 30);
                dispatch(getSession({
                    user: {
                        firstName: ""
                    }
                }))

            } else {

            }
            window.location.reload(true);
        })
    }
    const get_shipping_list_count = (e) => {
        return;

    }
    const getTotalRepackCost = (data) => {
        if (!data)
            return 0;
        var total = 0;
        Object.keys(data).map(key => { total += ((key != undefined && key != "undefined") ? Number(data[key]) : 0) })
        return total;
    }
    const getTotalRescanCost = (data) => {
        if (!data)
            return 0;
        var total = 0;
        Object.keys(data).map(key => { total += ((key != undefined && key != "undefined") ? Number(data[key]) : 0) })
        return total;
    }
    const calculateValues = (h, l, w, wt, weightAndVal, index, subcategories3, subcategories4, subcategories5, isCertificateprice, price, cPer, setValue, calculatedBasePrice, consolidationCharges1, additionalCharges, shippingCost, additionalCostForCalc, exchangeRateAmt, userType = 1, sp = 0, repackCost = {}, rescanCost1 = {}, couponD = null, storageSettings = null, storageValue = 0, params = null) => {
        var storageCost = storageValue ? storageValue : 0;
        var rCost = getTotalRepackCost(repackCost)
        var rescanCost = getTotalRescanCost(rescanCost1);
        rCost = Number(Number(rCost).toFixed(2));
        rescanCost = Number(Number(rescanCost).toFixed(2));
        if (params?.totalRescanCost_acc)
            rescanCost = Number(params.totalRescanCost_acc);
        if (params?.totalRepackCost_acc)
            rCost = Number(params.totalRepackCost_acc);
        price = Number(Number(price).toFixed(2));
        calculatedBasePrice = Number(Number(calculatedBasePrice ? calculatedBasePrice : 0).toFixed(2));
        var line66 = false;
        var consolidationCharges = params?.consolidationCharges_acc ? params.consolidationCharges_acc : consolidationCharges1;
        var chargWt = Number(h) * Number(l) * Number(w) / 5000;

        var twt = Number(chargWt > wt ? chargWt : wt);

        if (calculatedBasePrice) {
            twt = Math.min(twt, Number(calculatedBasePrice));
        }

        var minWeight = 0;
        var maxWeight = 0;
        var minVal = 0;
        try {
            minWeight = maxWeight = weightAndVal[0].wt
            weightAndVal.forEach((weightVal) => {
                var x = weightVal.wt;
                if (x > maxWeight) {
                    maxWeight = x;
                }
                if (x < minWeight) {
                    minWeight = x;
                }
            })
        } catch (e) {
            minWeight = 0.25;
            maxWeight = 26.9;
        }


        twt = Number(twt) <= minWeight ? minWeight : (Number(twt) > maxWeight ? maxWeight : Number(twt));
        var transportVal = 0;
        if (sp == 0) {
            for (var j = 0; j < weightAndVal.length; j++) {
                var weightVal = weightAndVal[j];
                if (weightVal.wt >= twt) {
                    transportVal = weightVal.val;
                    break;
                }
                if (!weightVal.wt && twt == minWeight) {
                    transportVal = weightVal.val;
                    break;
                }
            }
        } else {
            transportVal = sp;
        }
        if (params?.transportVal_acc != null)
            transportVal = Number(params.transportVal_acc);
        transportVal = Number(Number(transportVal).toFixed(2));
        var cD = cPer * Number(transportVal) / 100;
        var orgTotalCost = transportVal;
        if (couponD) {
            if (couponD.affiliate) {
                var totalForDeduction = Number(transportVal);
                cD = cPer * totalForDeduction / 100;
            }
            if (couponD.params.isFixedPrice) {
                if (Number(transportVal) < cPer)
                    cD = Number(transportVal);
                else
                    cD = cPer;
            }
        }
        cD = Number(Number(cD).toFixed(2));
        transportVal = transportVal - cD;
        if (subcategories5.length) {
            line66 = true;
        }
        var cif = Number(transportVal) + Number(price);
        var cCharge = params?.customsCharge_acc != null ? Number(params.customsCharge_acc) : 0;
        var cifX = 0;
        var pTax = params?.purchaseTax_acc != null ? Number(params.purchaseTax_acc) : 0;
        var pTotal = cif;
        var vat = 0;
        var shippingPrice = 0;
        var taxLimit = Number(additionalCostForCalc.cost75);
        if (shippingCost) {
            shippingPrice = Number(wt ? wt : 0) * shippingCost;
        }

        if (Number(price) > taxLimit) {
            cCharge = cif * Number(subcategories3[index]) / 100;
            cifX = cif * (1 + Number(subcategories3[index]) / 100);
            if (line66) {
                //cifX *= 1.6;
            }
            pTax = cifX * Number(subcategories4[index]) / 100;
            if (params?.purchaseTax_acc != null)
                pTax = Number(params.purchaseTax_acc);
            pTotal = cifX * (1 + Number(subcategories4[index]) / 100);
            
            vat = (price + shippingPrice) * Number(additionalCostForCalc.costPer) / 100;
        }
        var selfClearance = 0;
        if (userType == 2 || Number(price) > 1000)
            selfClearance = Number(additionalCostForCalc.costSelf);
        if (params?.selfClearance_acc != null)
            selfClearance = Number(params.selfClearance_acc);

        var addCharges = 0;
        var addCharges6Limit = Number(additionalCostForCalc.cost6Limit) < 100 ? 100 : Number(additionalCostForCalc.cost6Limit);
        var fixedFee = params?.fixedFee_acc != null ? Number(params.fixedFee_acc) : 0;
        var isCar = false;
        if (line66 && isCertificateprice) {
            cCharge = 0;
            cifX = 0;
            pTax = 0;
            pTotal = cif;
            vat = 0;
            if (subcategories5[index].isCar) {
                fixedFee = params?.fixedFee_acc != null ? Number(params.fixedFee_acc) : Number(additionalCostForCalc.costDoc);
                if (Number(price) > taxLimit) {
                    cCharge = cif * Number(subcategories3[index]) / 100;
                    cifX = cif * (1 + Number(subcategories3[index]) / 100);
                    pTax = cifX * Number(subcategories4[index]) / 100;
                    if (params?.purchaseTax_acc != null)
                        pTax = Number(params.purchaseTax_acc);
                    pTotal = cifX * (1 + Number(subcategories4[index]) / 100);
                    var pr = (price + shippingPrice) * (1 + Number(subcategories3[index]) / 100) * (1 + Number(subcategories4[index]) / 100);
                    vat = pr * Number(additionalCostForCalc.costPer) / 100; // ptax and cc is based on this
                    cCharge = (price + shippingPrice) * Number(subcategories3[index]) / 100;
                    if (params?.customsCharge_acc != null)
                        cCharge = Number(params.customsCharge_acc);
                    cifX = (price + shippingPrice) * (1 + Number(subcategories3[index]) / 100);
                    pTax = cifX * Number(subcategories4[index]) / 100;
                    if (params?.purchaseTax_acc != null)
                        pTax = Number(params.purchaseTax_acc);
                    pTotal = cifX * (1 + Number(subcategories4[index]) / 100);
                }
            } else {
                if (Number(price) > taxLimit) {
                    vat = (price + shippingPrice) * Number(additionalCostForCalc.costPer) / 100;
                }
            }
        } else {

        }
        var part45 = 0;
        var costSurcharge = 0;
        var securityFee = 0;
        var excRate = Number(exchangeRateAmt.rates.ILS) / Number(exchangeRateAmt.rates.USD);
        addCharges6Limit = Number(additionalCostForCalc.cost6Limit)
        if (Number(price) > addCharges6Limit && Number(price) < 500) {
            costSurcharge = additionalCostForCalc.cost6 / excRate;
        } else if (Number(price) >= 500 && Number(price) < 1000) {
            costSurcharge = additionalCostForCalc.cost20 / excRate;
            securityFee = additionalCostForCalc.cost48 / excRate;
        } else if (Number(price) >= 1000) {
            costSurcharge = additionalCostForCalc.cost25 / excRate;
            securityFee = additionalCostForCalc.cost48 / excRate;
        }
        addCharges += selfClearance;
        addCharges += costSurcharge;
        if (Number(h) > 110 || Number(l) > 110 || Number(w) > 110) {
            addCharges = addCharges + 40;
        }

        var insurence = (Number(price) * 3 / 100) < 2 ? 2 : (Number(price) * 3 / 100);
        insurence = Number(Number(insurence).toFixed(2));
        if (params?.insurence_acc != null)
            insurence = Number(params.insurence_acc);

        if (consolidationCharges) {
            addCharges = addCharges + Number(Number(consolidationCharges).toFixed(2));
            setValue(prev => ({ ...prev, cS: Number(Number(consolidationCharges).toFixed(2)) }));
        }
        var add = 0
        if (params?.additionalCharges_acc){
            add = params.additionalCharges_acc;
			additionalCharges = add;
        } else if (additionalCharges)
            add = additionalCharges;
        if (add) {
            addCharges = addCharges + Number(Number(add).toFixed(2));
            if (addCharges < 0)
                addCharges = 0;
            setValue(prev => ({ ...prev, aCUsed: Number(Number(additionalCharges).toFixed(2)) }));
        } else
            setValue(prev => ({ ...prev, aCUsed: 0 }));
        addCharges += rCost + rescanCost + storageCost;
        pTax = Number(Number(pTax).toFixed(2));
        cCharge = Number(Number(cCharge).toFixed(2));
        vat = Number(Number(vat).toFixed(2));
        addCharges = Number(Number(addCharges).toFixed(2));
        fixedFee = Number(Number(fixedFee).toFixed(2));
        var returnToShipper = params?.returnToShipper_acc ? Number(params.returnToShipper_acc)  :0;
        var totalInvoice = Number(Number(transportVal).toFixed(2))
            + Number(Number(pTax).toFixed(2))
            + Number(Number(cCharge).toFixed(2))
            + Number(Number(vat).toFixed(2))
            + Number(Number(addCharges).toFixed(2))
            + Number(Number(fixedFee).toFixed(2))
            // + Number(Number(insurence).toFixed(2))
            + Number(Number(returnToShipper).toFixed(2));
        if (Number.isNaN(totalInvoice)) {
            return false;
        }
        setValue(prev => ({ ...prev, len: l }));
        setValue(prev => ({ ...prev, wid: w }));
        setValue(prev => ({ ...prev, hei: h }));
        setValue(prev => ({ ...prev, wgt: wt }));
        setValue(prev => ({ ...prev, constWt: calculatedBasePrice }));

        setValue(prev => ({ ...prev, storageCost: storageCost }));
        setValue(prev => ({ ...prev, costSurcharge: costSurcharge }));
        setValue(prev => ({ ...prev, fixedFee: fixedFee }));
        setValue(prev => ({ ...prev, price1: price }));
        setValue(prev => ({ ...prev, transportVal: transportVal }));
        setValue(prev => ({ ...prev, totalInvoice: totalInvoice }));
        setValue(prev => ({ ...prev, cif: cif }));
        setValue(prev => ({ ...prev, customsCharge: cCharge }));
        setValue(prev => ({ ...prev, vat: vat }));
        setValue(prev => ({ ...prev, vatPer: additionalCostForCalc.costPer }));
        setValue(prev => ({ ...prev, rCost: rCost }));
        setValue(prev => ({ ...prev, rescanCostVal: rescanCost }));
        setValue(prev => ({ ...prev, consolidationCharges: consolidationCharges }));
        setValue(prev => ({ ...prev, purchaseTax: pTax }));
        setValue(prev => ({ ...prev, insurence: insurence }));
        setValue(prev => ({ ...prev, cD: cD }));
        setValue(prev => ({ ...prev, addCharges: addCharges }));
        setValue(prev => ({ ...prev, additionalCharges: additionalCharges }));
        setValue(prev => ({ ...prev, orgTotalCost: orgTotalCost }));
        setValue(prev => ({ ...prev, repackCost: rCost }));
        setValue(prev => ({ ...prev, pWt: twt }));
        setValue(prev => ({ ...prev, selfClearance: selfClearance }));
        setValue(prev => ({ ...prev, securityFee: securityFee }));
        setValue(prev => ({ ...prev, part45: part45 }));
        setValue(prev => ({ ...prev, returnToShipper: returnToShipper }));
        setValue(prev => ({ ...prev, wS: calculatedBasePrice == twt ? ("Content form") : ((Number(wt).toFixed(1) == Number(twt) || Number(wt) == Number(twt)) ? "Actual Weight" : "Calculated weight") }));
        /**/
        return true;
    }
    const getShippingCoPickupPointsBySh = () => {

    }
    const keyPressed = (e) => {
        if (e.keyCode === 13) {

        }
    }
    useEffect(() => {
        doPing();




    }, [dispatch, isLogin]);
    const [targetAction, setTargetAction] = useState("");
    const [openOrderModal, setOpenOrderModal] = useState(false);
    const onHandleOpenModal = (add, ind) => {
        setOpenOrderModal(true);
    };
    const onHandleCancelModal = () => setOpenOrderModal(false);


    const [openOrderModalRegistration, setOpenOrderModalRegistration] = useState(false);
    const onHandleOpenModalRegistration = (add, ind) => {
        setOpenOrderModalRegistration(true);
    };
    const onHandleCancelModalRegistration = () => setOpenOrderModalRegistration(false);

    const [openOrderModalLogin, setOpenOrderModalLogin] = useState(false);
    const onHandleOpenModalLogin = (add, ind) => {
        setOpenOrderModalLogin(true);
    };
    const onHandleCancelModalLogin = () => setOpenOrderModalLogin(false);




    if (!isLoading) {

        setIsLoading(true)
        // if (window.location == "https://redboxparcel.com" || window.location == "https://redboxparcel.com/home")
        //onHandleOpenModal(true)
        /*if (window.location != "https://redboxparcel.com/nbo" || window.location != "https://redboxparcel.com") {
            window.location= "https://redboxparcel.com"
        }*/
        var action = get_params("action")
        var token = get_params("token")
        if (action === 'changePass' && token != "") {
            checkForgotPasswordRequestExists(token, function (res) {
                if (res === "SUCCESS") {
                    setIsChangePass(true)
                    setIsForgot(true)
                    setTokenForCh(token)
                } else {
                    setOpenTokenErrorDialog(true)
                }
            });
        }
        var cont = true;
        if (cont) {
            if (action === 'registration' && token == "true") {
                setIsRegister(true)
                //setIsForgot(true)
                // setActiveScreenInreg("OTPVerify")
                //setTokenForCh(token)
            }

            window.setTimeout(function () {
                console.log(window.location.href)
                var ht = window.location.href;
                var htArr = ht.split("/")
                if (htArr[htArr.length - 1].split("?")[0] === "orcaReg")
                    setTargetAction("orcaReg");
                if (htArr[htArr.length - 1].split("?")[0] === "Register")
                    setIsRegister(true)
                var action = get_params("target")
                if (action) {
                    switch (action) {
                        case 'home':
                            navigate("/home");
                            break;
                        case 'newHome':
                            navigate("/new-home");
                            break;
                        case 'FAQS':
                            /*var urlParams = new URLSearchParams(window.location.search);
                            var id = ""
                            if (urlParams.has("id"))
                                id = "?id="+urlParams.get("id");*/
                            navigate("/FAQS");
                            break;
                        case 'howto':
                            /*var urlParams = new URLSearchParams(window.location.search);
                            var id = ""
                            if (urlParams.has("id"))
                                id = "?id="+urlParams.get("id");*/
                            navigate("/howto");
                            break;
                        case 'store':
                            navigate("/store");
                            break;
                        case 'redboxPricing':
                            navigate("/redboxPricing");
                            break;
                        case 'comparePrices':
                            navigate("/comparePrices");
                            break;
                        case 'aboutUs':
                            navigate("/aboutUs");
                            break;
                        case 'blog':
                            var args = htArr[htArr.length - 1].split('&');
                            var str = "";
                            for (var i = 0; i < args.length; i++) {
                                if (!args[i].includes("target")) {
                                    str += args[i];
                                }
                            }
                            str = str.replace("?", "");
                            console.log(str);
                            navigate("/blog" + (str ? "?" + str : ""));
                            break;
                        case 'accounts':
                            navigate("/accounts");
                            break;
                        case 'contactUs':
                            navigate("/contactUs");
                            break;
                        case 'orcaReg':
                            navigate("/orcaReg");
                            setTargetAction("orcaReg");
                            break;
                        case '/login':
                            setOpenOrderModalLogin(true);
                            break;
                        case 'login':
                            setIsLogin(true);
                            break;
                        case 'Register':
                            setIsRegister(true)
                            break;
                        default:
                            navigate("/home");

                    }
                }
                if (get_params("id"))
                    document.getElementById(get_params("id")).scrollIntoView();
            }, 100);
        }
    }

    const [openTokenErrorDialog, setOpenTokenErrorDialog] = new useState(false);
    // Cookie notice: website only. Inside the Redbox mobile apps the privacy policy is shown in the store listing.
    const [openConsentDialog, setOpenConsentDialog] = new useState(!isNativeApp());
    const onConsentAccept = () => {
        setOpenConsentDialog(false);
        setCookie("redBoxAcceptanceCookie", "1", 365)
    }
    useEffect(() => {

        var action = get_params("action")
        var token = get_params("token")
        if (action === 'regActivate' && token != "") {
            /*setIsRegister(true)
            //setIsForgot(true)
            setActiveScreenInreg("OTPVerify")
            setTokenForCh(token)*/
            var d = {
                token: token
            }
            setIsLoading1(true)
            activateRegister(d, function (response) {
                setIsLoading1(false)
                if (response?.misc?.CODE ? response.misc.CODE === 1 : false) {
                    dispatch(snackbarToggle({ type: 'success', message: "חשבון אושר בהצלחה" }));
                    //handleScreenData(screens[3]);
                    //setOpenOrderModalRegistration(true)
                    setCookie("SESSION_ID", response.session, 30);
                    dispatch(getSession(response))
                    window.setTimeout(function () {
                        window.location.href = "/";
                    }, 2000);

                } else {
                    dispatch(snackbarToggle({ type: 'error', message: "חשבון כבר אושר" }));
                    window.setTimeout(function () {
                        window.location.href = "/";
                    }, 2000);
                }
            });
        }
        if (getCookie("redBoxAcceptanceCookie") === "1") {
            setOpenConsentDialog(false);
        }
    }, []);


    return (
        <>{isLoading1 ? <div style={{ zIndex: "9999999", color: "red", background: "white", height: "100vh", width: "100vw", textAlign: "center", marginTop: "46vh", fontSize: "8vh" }}>
            <img src="/Spin-loader.gif" alt="Activating ..." />
        </div> : <>

                {
                    openConsentDialog && (
                        <Dialog maxWidth='md' open={openConsentDialog}>
                            <Grid item container style={{ maxWidth: "700px" }}>
                                <Grid item container sm={12} style={{ height: "15vh", fontSize: "20px", margin: "10px" }} justifyContent="center" alignItems="center">
                                    <div style={{ textAlign: "center", direction: "rtl" }}>
                                        {`אתר אינטרנט זה משתמש בטכנולוגיות איסוף נתונים`} {`בעזרת קובצי`} {`Cookie  `} <br /> <br />
                                        {`למידע נוסף, אנא עיין`} <span> <a target="_blank" href="https://redboxparcel.com/מדיניות%20פרטיות1.pdf">{`במדיניות הפרטיות`}</a></span> {`שלנו.`}
                                    </div>
                                </Grid>
                                <Grid item container sm={12} style={{ height: "", width: "100%", margin: "10px", marginTop: "40px" }} justifyContent="center">
                                    <Button variant='contained' sx={{ m: 2, borderRadius: "25px", background: "#FF3452", padding: "3px", paddingLeft: "20px", paddingRight: "20px" }} onClick={() => {
                                        onConsentAccept();
                                    }}>{`אני מסכים/ה`}</Button>
                                </Grid>
                            </Grid>
                        </Dialog>
                    )
                }
                {
                    openTokenErrorDialog && (
                        <Dialog maxWidth='md' open={openTokenErrorDialog}>
                            <Grid item container style={{ maxWidth: "500px" }}>
                                <Grid item container sm={12} style={{ height: "40px", fontSize: "20px", margin: "10px" }} justifyContent="center" alignItems="center">
                                    { "The link you followed has expired."}
                                </Grid>
                                <Grid item container sm={12} style={{ height: "", width: "100%", margin: "10px" }} justifyContent="center">
                                    <Button variant='contained' sx={{ m: 2, borderRadius: "25px", background: "#FF3452", padding: "3px", paddingLeft: "20px", paddingRight: "20px" }} onClick={() => {
                                        setOpenTokenErrorDialog(false);
                                        window.location = "/";
                                    }}>{ `OK`}</Button>
                                </Grid>
                            </Grid>
                        </Dialog>
                    )
                }
            {<Paper sx={{ width: '100%' }}>
                <div id="page" className="hfeed site mm-page mm-slideout">
                    {targetAction !== "orcaReg" && <HeHeader setIsProfile={setIsProfile} setIsAddAddress={setIsAddAddress} logOutUser={logOutUser} setIsRegister={setIsRegister} setActiveScreenInreg={setActiveScreenInreg} setIsLogin={setIsLogin} />}
                    {location.pathname == '/new-home' && false && <NewHomeHeader setIsProfile={setIsProfile} setIsAddAddress={setIsAddAddress} logOutUser={logOutUser} setIsRegister={setIsRegister} setActiveScreenInreg={setActiveScreenInreg} setIsLogin={setIsLogin} />}
                    {openOrderModal && (
                        <Dialog maxWidth='sm' open={openOrderModal} title={``} onHandleCancel={onHandleCancelModal} >
                            <div style={{ overflow: "hidden", maxWidth: "480px", minHeight: "180px" }}>
                                <Grid container item justifyContent="flex-end" sx={{ fontSize: "20px" }}>
                                    <Button variant='text' sx={{ borderRadius: "25px", padding: "3px" }} onClick={() => {
                                        onHandleCancelModal()
                                    }}>&nbsp;</Button>
                                </Grid>
                                <Grid container item justifyContent="center" sx={{ fontSize: "20px", marginTop: "-30px" }}>
                                    <img src={loadBanner} style={{ width: "480px" }} onClick={() => {
                                        onHandleCancelModal();
                                        if (userInfo.session) {
                                            navigate("/accounts")
                                        } else {
                                            setIsRegister(true)
                                            //navigate("/home")
                                        }
                                    }} />
                                </Grid>
                                {/*<Grid container item justifyContent="flex-start" sx={{ fontSize: "20px", marginTop: "-28%", marginLeft: "42%" }}>
                                    <Button sx={{ width: "300px", height: "90px" }} variant='text' onClick={() => {
                                        onHandleCancelModal();
                                        if (userInfo.session) {
                                            navigate("/accounts")
                                        } else {
                                            setIsRegister(true)
                                            //navigate("/home")
                                        }
                                    }}> &nbsp;</Button>
                                </Grid>*/}
                            </div>
                        </Dialog>
                    )}

                    {openOrderModalRegistration && (
                        <Dialog maxWidth='sm' open={openOrderModalRegistration} title={``} onHandleCancel={onHandleCancelModalRegistration} >
                            <div style={{ overflow: "hidden", maxWidth: "480px", minHeight: (isMobile() ? "0" : "240px") }}>
                                {false && <Grid container item justifyContent="flex-end" sx={{ fontSize: "20px" }}>
                                    <Button variant='text' sx={{ borderRadius: "25px", padding: "3px" }} onClick={() => {
                                        onHandleCancelModalRegistration()
                                    }}>&nbsp;</Button>
                                </Grid>}
                                <Grid container item justifyContent="center" sx={{ fontSize: "20px", marginTop: "-30px" }}>
                                    <img src={postReg} style={{ width: "480px" }} onClick={() => {
                                        onHandleCancelModalRegistration();
                                        if (userInfo.session) {
                                            navigate("/accounts")
                                            setIsAddAddress(false)
                                        } else {
                                            setIsRegister(true)
                                            //navigate("/home")
                                        }
                                    }} />
                                </Grid>
                                {<Grid container item justifyContent="flex-start" sx={{ fontSize: "20px", marginTop: "-15%", marginLeft: "43%" }}>
                                    <Button style={{ minWidth: (isMobile() ? "53px" : "94px") }} variant='text' onClick={() => {
                                        onHandleCancelModalRegistration();
                                        if (userInfo.session) {
                                            navigate("/store")
                                            setIsRegister(false)
                                        } else {
                                            setIsRegister(true)
                                            //navigate("/home")
                                        }
                                    }}> &nbsp;</Button>

                                    <Button style={{ minWidth: "94px" }} variant='text' onClick={() => {
                                        onHandleCancelModalRegistration();
                                        if (userInfo.session) {
                                            navigate("/accounts")
                                            setIsRegister(false);
                                        } else {
                                            setIsRegister(true)
                                            //navigate("/home")
                                        }
                                    }}> &nbsp; </Button>
                                </Grid>}
                            </div>
                        </Dialog>
                    )}

                    {openOrderModalLogin && (
                        <Dialog style={{ marginLeft: "0", marginRight: "0" }} maxWidth='sm' direction="rtl" open={openOrderModalLogin} title={`ברוך שובך`} onHandleCancel={onHandleCancelModalLogin} >
                            <div style={{ overflow: "hidden", maxWidth: "480px", minHeight: (isMobile() ? "0" : "240px") }}>
                                <Grid container item justifyContent="center" sx={{ fontSize: "20px", marginTop: "-30px" }}>
                                    <img alt="" src={loginPopup} style={{ width: "480px" }} onClick={() => {
                                        onHandleCancelModalLogin();
                                        if (userInfo.session) {
                                            navigate("/accounts")
                                            setIsAddAddress(false)
                                        } else {
                                            setIsRegister(true)
                                            //navigate("/home")
                                        }
                                    }} />
                                    <Button style={{ color: "red", fontWeight: "bold", fontSize: "22px" }} variant='text' onClick={() => {
                                        onHandleCancelModalLogin()
                                    }}> {`סגור`} </Button>
                                </Grid>
                            </div>
                        </Dialog>
                    )}
                    {<div className="inner_content" id="inner_content" style={{ paddingTop: targetAction === "orcaReg" ? "0 !important" : "82px" }}>
                        <div id="innerContent" className="">
                            <Wrapper>
                                <Routes>
                                    {/*<Route exact path='/*' element={<Home setIsLogin={setIsLogin} setIsRegister={setIsRegister} />} />*/}
                                    <Route exact path='/*' element={<NewHome setActiveScreenInreg={setActiveScreenInreg} setIsLogin={setIsLogin} setIsRegister={setIsRegister} />} />
                                    <Route exact path='/new-home' element={<NewHome setActiveScreenInreg={setActiveScreenInreg} setIsLogin={setIsLogin} setIsRegister={setIsRegister} />} />
                                    <Route exact path='/howItWorks' element={<HowItWorks />} />
                                    <Route exact path='/usRetailers' element={<UsRetailers />} />
                                    <Route exact path='/redboxPricing' element={<RedboxPricing calculateValues={calculateValues} setIsRegister={setIsRegister} setActiveScreenInreg={setActiveScreenInreg} />} />
                                    <Route exact path='/FAQS' element={<FAQS setIsLogin={setIsLogin} setActiveScreenInreg={setActiveScreenInreg} setIsRegister={setIsRegister} />} />
                                    <Route exact path='/howto' element={<Howto setIsLogin={setIsLogin} setActiveScreenInreg={setActiveScreenInreg} setIsRegister={setIsRegister} />} />
                                    <Route exact path='/contactUs' element={<ContactUs setActiveScreenInreg={setActiveScreenInreg} setIsLogin={setIsLogin} setIsRegister={setIsRegister} />} />
                                    <Route exact path='/accounts' element={<Accounts isBuyMePayment={isBuyMePayment} setIsBuyMePayment={setIsBuyMePayment} setIsProfile={setIsProfile} couponList={couponList} setCouponList={setCouponList} setIsLogin={setIsLogin} setActiveScreenInreg={setActiveScreenInreg} setIsRegister={setIsRegister} setIsAddAddress={setIsAddAddress} setIsPersonal={setIsPersonal} />} />
                                    <Route exact path='/orcaReg' element={<OrcaReg isBuyMePayment={isBuyMePayment} setIsChangePass={setIsChangePass} setIsForgot={setIsForgot} setIsBuyMePayment={setIsBuyMePayment} setIsProfile={setIsProfile} couponList={couponList} setCouponList={setCouponList} setIsLogin={setIsLogin} setActiveScreenInreg={setActiveScreenInreg} setIsRegister={setIsRegister} setIsAddAddress={setIsAddAddress} setIsPersonal={setIsPersonal} />} />
                                    <Route exact path='/ParcelStatus' element={<Status />} />
                                    <Route exact path='/store' element={<Store couponList={couponList} setCouponList={setCouponList} setIsLogin={setIsLogin} setActiveScreenInreg={setActiveScreenInreg} setIsRegister={setIsRegister} setIsPersonal={setIsPersonal} />} />
                                    <Route exact path='/comparePrices' element={
                                        <>
                                            <MetaTags id="comparePrices">
                                                <title>Compare Prices </title>
                                            </MetaTags>
                                            <Compare setIsLogin={setIsLogin} setActiveScreenInreg={setActiveScreenInreg} setIsRegister={setIsRegister} setIsPersonal={setIsPersonal} />
                                        </>} />
                                    <Route exact path='/aboutUs' element={<>
                                        <MetaTags id="aboutUs">
                                            <title>About Us </title>
                                        </MetaTags>
                                        <About setIsLogin={setIsLogin} setActiveScreenInreg={setActiveScreenInreg} setIsRegister={setIsRegister} setIsPersonal={setIsPersonal} /> </>} />
                                    <Route exact path='/blog' element={<Blog />} />
                                    <Route exact path='/delete-account' element={<DeleteAccount />} />
                                    {/*<Route exact path='/accounts' element={<Accounts setIsLogin={setIsLogin} setActiveScreenInreg={setActiveScreenInreg} setIsRegister={setIsRegister} setIsPersonal={setIsPersonal} />} />*/}

                                </Routes>
                            </Wrapper>
                        </div>
                        {targetAction !== "orcaReg" &&
                            < footer className="site-footer" id="main_page_footer">
                                <Footer setIsRegister={setIsRegister} />
                            </footer>
                        }
                    </div>}
                </div>

            </Paper>}
            {snackbar && (
                /* snackbar<Snackbar
                     open={!!snackbar}
                     message={snackbar.message}
                     type={snackbar.type}
                     onClose={onSnackbarHandleClose}
                 />*/
                <AlertDialog
                    open={!!snackbar}
                    message={snackbar.message}
                    type={snackbar.type}
                    onHandleCancel={onSnackbarHandleClose}
                />/**/
            )}
            {isRegister && <Registration setOpenOrderModalRegistration={setOpenOrderModalRegistration} tokenForCh={tokenForCh} setIsAddAddress={setIsAddAddress} setIsChangePass={setIsChangePass} setActiveScreenInreg={setActiveScreenInreg} activeScreenInreg={activeScreenInreg} isRegister={isRegister} setIsRegister={setIsRegister} setIsLogin={setIsLogin} />}
            {isLogin && <Login setIsActivateUser={setIsActivateUser} setIsChangePass={setIsChangePass} setIsPersonal={setIsPersonal} isLogin={isLogin} setIsLogin={setIsLogin} setIsRegister={setIsRegister} setIsForgot={setIsForgot} get_shipping_list_count={get_shipping_list_count} />}
            {isActivateUser && <ActivateUser setActiveScreenInreg={setActiveScreenInreg} tokenForCh={tokenForCh} isChangePass={isChangePass} setIsChangePass={setIsChangePass} isForgot={isForgot} isActivateUser={isActivateUser} setIsLogin={setIsLogin} setIsForgot={setIsForgot} setIsRegister={setIsRegister} setIsActivateUser={setIsActivateUser} />}
            {isForgot && <Forgot tokenForCh={tokenForCh} isChangePass={isChangePass} setIsChangePass={setIsChangePass} isForgot={isForgot} setIsLogin={setIsLogin} setIsForgot={setIsForgot} setIsRegister={setIsRegister} />}
            {isPersonal && <Personal calculateValues={calculateValues} couponList={couponList} get_shipping_list_count={get_shipping_list_count} isPersonal={isPersonal} setIsPersonal={setIsPersonal} />}
            {isBuyMePayment && <BuyMePayment isBuyMePayment={isBuyMePayment} calculateValues={calculateValues} couponList={couponList} get_shipping_list_count={get_shipping_list_count} isPersonal={isPersonal} setIsBuyMePayment={setIsBuyMePayment} />}
            {isAddAddress && <AddAddress isAddAddress={isAddAddress} setIsProfile={setIsProfile} setIsAddAddress={setIsAddAddress} />}
            {isProfile && <Profile doPing={doPing} isProfile={isProfile} setIsAddAddress={setIsAddAddress} setIsProfile={setIsProfile} />}

        </>}</>
    );
}

export default LandingPage;